import {
  ReflectionGenderEnum,
  ReflectionIdcardTypeEnum,
  ReflectionPupilTypeEnum,
  ReflectionRoleEnum,
  ReflectionStatusEnum,
} from 'packages/sdks-next/growp'
import {
  genderToLabel,
  guardianTypeToLabel,
  idcardTypeToLabel,
  roleToLabel,
  statusToLabel,
} from './dataMap'

// 生源池-不可编辑信息，即非自定义信息
export const notEditableKeys: string[] = [
  'name',
  'graduate',
  'phone',
  'registed_at',
  'gender',
  'status',
  'avatar',
  'activity_names',
  'account',
  'usin',
  'idcard',
  'idcard_type',
  'email',
  'guardians.0.name',
  'guardians.0.pupil_type',
  'guardians.0.phone',
  'guardians.1.name',
  'guardians.1.pupil_type',
  'guardians.1.phone',
]

// 生源池-仅支持精确筛选的keys
export const accurateSearchKeys: string[] = [
  'gender',
  'status',
  'idcard_type',
  'idcard',
  'email',
  'graduate',
]

export const optShowLabel: { [key: string]: (name: any) => void } = {
  role: (name: ReflectionRoleEnum) => roleToLabel.get(name),
  gender: (name: ReflectionGenderEnum) => genderToLabel.get(name),
  status: (name: ReflectionStatusEnum) => statusToLabel.get(name),
  idcardType: (name: ReflectionIdcardTypeEnum) => idcardTypeToLabel.get(name),
  'guardians.0.pupilType': (name: ReflectionPupilTypeEnum) =>
    guardianTypeToLabel.get(name),
  'guardians.1.pupilType': (name: ReflectionPupilTypeEnum) =>
    guardianTypeToLabel.get(name),
}

export const guardiansFixedKeys = [
  'guardians.0.pupil_type',
  'guardians.1.pupil_type',
]
